import { useState } from "react";

export default function AuthorCard({ author, index }) {
    const [hovered, setHovered] = useState(false);

    return (
        <div
            style={{
                animation: `fadeUp 0.6s cubic-bezier(0.16, 1, 0.3, 1) ${index * 0.08}s both`
            }}
        >
            <div
                style={{
                    animation: `float 4s ease-in-out ${1 + index * 0.2}s infinite`
                }}
            >
                <div
                    onMouseEnter={() => setHovered(true)}
                    onMouseLeave={() => setHovered(false)}
                    style={{
                        background: "var(--paper)",
                        border: "1.5px solid var(--border)",
                        borderRadius: "16px",
                        overflow: "hidden",
                        transition: "box-shadow 0.35s ease",
                        boxShadow: hovered ? "var(--shadow-lg)" : "none",
                        cursor: "pointer",
                    }}
                >
                    {/* Photo */}
                    <div style={{
                        width: "100%",
                        aspectRatio: "1",
                        overflow: "hidden",
                        background: "var(--cream2)",
                        position: "relative"
                    }}>
                        <img
                            src={author.img}
                            alt={author.name}
                            style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                                display: "block",
                                transition: "transform 0.6s ease",
                                transform: hovered ? "scale(1.08)" : "scale(1)",
                            }}
                        />
                        {hovered && (
                            <div style={{
                                position: "absolute", inset: 0,
                                background: "rgba(28,58,42,0.6)",
                                display: "flex", alignItems: "center", justifyContent: "center",
                                padding: 20, textAlign: "center", animation: "fadeUp 0.3s ease"
                            }}>
                                <p style={{ color: "white", fontSize: 12, lineHeight: 1.6, margin: 0, fontWeight: 500 }}>
                                    {author.bio}
                                </p>
                            </div>
                        )}
                    </div>

                    {/* Info */}
                    <div style={{ padding: "14px 16px" }}>
                        <p style={{
                            margin: 0,
                            fontFamily: "'Playfair Display', serif",
                            fontSize: "1rem",
                            fontWeight: 700,
                            color: "var(--forest)",
                            lineHeight: 1.2,
                        }}>
                            {author.name}
                        </p>
                        <p style={{
                            margin: "4px 0 0",
                            fontSize: "0.65rem",
                            fontWeight: 700,
                            color: "var(--terra)",
                            letterSpacing: "0.06em",
                            textTransform: "uppercase",
                        }}>
                            {author.role}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};